module.exports = __webpack_public_path__ + "img/regSupp-2.530ca8da.jpg";